import { queryOptions } from "@tanstack/react-query";
import { fetchActivity, fetchNfts, fetchOverview, fetchXrpUsd } from "./xrpl";
import { cached, readCache } from "./cache";
import type { AccountOverview, LedgerActivity, NftItem } from "./xrpl";

export const overviewQuery = (address: string | null) => {
  const key = `overview:${address ?? ""}`;
  const seed = address ? readCache<AccountOverview>(key) : undefined;
  return queryOptions({
    queryKey: ["overview", address],
    queryFn: cached(key, () => fetchOverview(address as string)),
    enabled: Boolean(address),
    staleTime: 15_000,
    refetchInterval: 30_000,
    retry: 1,
    // Paint the last known balance immediately, then refresh in the background.
    ...(seed ? { initialData: seed, initialDataUpdatedAt: 0 } : {}),
  });
};

export const nftsQuery = (address: string | null) => {
  const key = `nfts:${address ?? ""}`;
  const seed = address ? readCache<NftItem[]>(key) : undefined;
  return queryOptions({
    queryKey: ["nfts", address],
    queryFn: cached(key, () => fetchNfts(address as string)),
    enabled: Boolean(address),
    staleTime: 60_000,
    retry: 1,
    ...(seed ? { initialData: seed, initialDataUpdatedAt: 0 } : {}),
  });
};

export const priceQuery = (enabled: boolean) => {
  const seed = readCache<number | null>("xrp-usd");
  return queryOptions({
    queryKey: ["xrp-usd", enabled],
    queryFn: cached("xrp-usd", () => fetchXrpUsd()),
    enabled,
    staleTime: 60_000,
    refetchInterval: 120_000,
    retry: 0,
    ...(seed !== undefined ? { initialData: seed, initialDataUpdatedAt: 0 } : {}),
  });
};

export const activityQuery = (address: string | null) => {
  const key = `activity:${address ?? ""}`;
  const seed = address ? readCache<LedgerActivity[]>(key) : undefined;
  return queryOptions({
    queryKey: ["activity", address],
    queryFn: cached(key, () => fetchActivity(address as string, 100)),
    enabled: Boolean(address),
    staleTime: 20_000,
    retry: 1,
    ...(seed ? { initialData: seed, initialDataUpdatedAt: 0 } : {}),
  });
};
